import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
import { InfoExpand, Loading } from "../FiltroBusqueda/actions";
import axios from 'axios';

export const cargarPaginacion = (paginacion) => ({
  type: "CARGAR_PAGINACION",
  paginacion,
});

export const cargarResultados = (prestacionesPP) => ({
  type: "CARGAR_PRESTACIONES_PP",
  prestacionesPP,
});

export const BuscarPrestacionesPP = (pagina, totalPagina) => (dispatch) => {
  const filtrosState = store.getState().filtroBusqueda;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: filtrosState.filtros.tipoAtencion === "0" ? null : filtrosState.filtros.tipoAtencion,
    Isapre: globalState.isapre,
    pageNumber: pagina,
    pageSize: totalPagina,
    token: globalState.token,
  };

  // console.log("DATA DESDE prestaciones/prestador2 componente");
  // console.log(params);

  axios({
    url: `${apiConfig.apiUri}/v1/prestaciones/prestador2/`,
    method: "POST",
    headers: {},
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
  }).then((response) => {
    //console.log("RESPONSE PAGINACION REAJUSTE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    //console.log(response.data);
    if (response.status === 200) {
      if (Array.isArray(response.data)) {
        dispatch(cargarResultados(response.data));
        //dispatch(Loading(false));
      } else { throw response.data; }
    } else {
      throw response.data;
    }
  }).catch((error) => {
    //console.log("RESPONSE PAGINACION REAJUSTE >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
    trace.error("BuscarPrestacionesPP", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });

  // fetch(`${apiConfig.apiUri}/v1/prestaciones/prestador2/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: { data: JSON.stringify(params) },
  // })
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw response;
  //     }
  //     return response.json();
  //   })
  //   .then((json) => {
  //     console.log("RESPONSE BUSCAR PRESTACIONES PP: ");
  //     console.log(json);
  //     if (Array.isArray(json)) {
  //       trace.information("BuscarPrestacionesPP", json);
  //       dispatch(cargarResultados(json));
  //       dispatch(Loading(false));
  //     } else {
  //       throw json;
  //     }
  //   })
  //   .catch((error) => {
  //     trace.error("BuscarPrestacionesPP", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al buscar las prestaciones:",
  //       error,
  //     ));
  //   });
};

export const CargarDatosPaginacion = (pagina) => (dispatch) => {
  const filtrosState = store.getState().filtroBusqueda;
  const globalState = store.getState().global;
  const params = {
    RutPrest: globalState.rutInstitucion,
    CentroMedico: globalState.filtros_CAT.centroAtencion,
    Arancel: globalState.filtros_CAT.tipoArancel,
    Codinterno: globalState.filtros_CAT.codPrestacion,
    Codfonasa: globalState.filtros_CAT.codFonasa,
    Grupo: globalState.filtros_CAT.tipoPrestacion,
    TipoAtencion: filtrosState.filtros.tipoAtencion === "0" ? null : filtrosState.filtros.tipoAtencion,
    Isapre: globalState.isapre,
    totalPagina: pagina,
    token: globalState.token,
  };

  //console.log("PAGINACION A MODIFICAR 3")
  axios({
    method: "POST",
    headers: {},
    credentials: "same-origin",
    data: { data: JSON.stringify(params) },
    url: `${apiConfig.apiUri}/v1/prestaciones/total-registros/`,
  }).then((response) => {
    if (response.status !== 200) {
      throw response.data;
    }

    if (Array.isArray(response.data)) {
      //trace.information("CargarDatosPaginacion", response.data);
      dispatch(cargarPaginacion(response.data));
    } else {
      throw response.data;
    }
  }).catch((error) => {
    trace.error("CargarDatosPaginacion", error);
    dispatch(ErrorSnacktOpen(
      "Error al buscar las prestaciones:",
      error,
    ));
  });
  // fetch(`${apiConfig.apiUri}/v1/prestaciones/total-registros/`, {
  //   method: "POST",
  //   headers: {
  //     // "Content-Type": "application/json",
  //     // Authorization: localStorage.getItem('id_token'),
  //   },
  //   credentials: "same-origin",
  //   body: JSON.stringify(params),
  // })
  //   .then((response) => {
  //     if (!response.ok) {
  //       throw response;
  //     }
  //     return response.json();
  //   })
  //   .then((json) => {
  //     if (Array.isArray(json)) {
  //       trace.information("CargarDatosPaginacion", json);
  //       dispatch(cargarPaginacion(json));
  //     } else {
  //       throw json;
  //     }
  //   })
  //   .catch((error) => {
  //     trace.error("CargarDatosPaginacion", error);
  //     dispatch(ErrorSnacktOpen(
  //       "Error al buscar las prestaciones:",
  //       error,
  //     ));
  //   });
};
